import apiUtils from '@utils/apiUtils';
import { apiConstants } from '@utils/constants';
import dateUtils from '@utils/dateUtils';
import { fetchAPI } from './apiServiceHelper';

const defaultGetParam = apiUtils.getDefaultGetParams();

let api = {
    commissionDetails: {
        get: ({ filter, limit, offset } = defaultGetParam) => {
            const partnerIds = apiUtils.normalizeOptionsArrayToString(filter.partners, 'id');
            const partnerOrderStatuses = apiUtils.normalizeOptionsArrayToString(
                filter.orderTmStatuses,
                'value'
            );

            return fetchAPI.getList(
                `${apiConstants.BASE_URL}/api/order/commission-detail`,
                apiUtils.normalizeQueryParams({
                    from: dateUtils.formatQueryParam(filter.from),
                    to: dateUtils.formatQueryParam(filter.to),
                    partnerIds,
                    partnerOrderStatuses,
                    ordersSummary: offset === 0,
                    limit,
                    offset,
                })
            );
        },
    },
};

export default api;
